var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "form-info" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form-row" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.devcInfoForm.name))])
          ])
        ]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.devcInfoForm.itemList, border: "" }
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "label",
                label: "标签",
                align: "left",
                width: "500"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "value", label: "内容", align: "left" }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("信息单")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "content-caption dashed",
        staticStyle: { "margin-top": "50px" }
      },
      [_c("span", [_vm._v("信息单项")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f882222a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f882222a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/DevcInfoFormDetail.vue
// module id = 3083
// module chunks = 0